// src/templates/mobile/CardsMobile.jsx
import React, { useState } from "react";
import { 
  IconPhone, 
  IconEmail, 
  IconStatus, 
  IconEdit, 
  IconEye, 
  IconTrash, 
  IconSearch,
  IconClose 
} from "../../components/Icons/Icons";

function CardsMobile({ 
  usuarios, 
  onNovoUsuario, 
  onEditarUsuario, 
  onVisualizarUsuario,
  onExcluirUsuario,
  onHome 
}) {
  const [searchTerm, setSearchTerm] = useState("");
  
  const filteredUsers = usuarios.filter(u => 
    u.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
    u.nivel.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getNivelBadgeClass = (nivel) => {
    const nivelLower = nivel.toLowerCase();
    if (nivelLower.includes("gestor")) return "badge-gestor";
    if (nivelLower.includes("admin")) return "badge-admin";
    if (nivelLower.includes("senior") || nivelLower.includes("sênior")) return "badge-senior";
    return "badge-tecnico";
  };

  const getInitials = (nome) => {
    return nome.split(" ").map(n => n[0]).slice(0, 2).join("").toUpperCase();
  };

  return (
    <>
      <div className="m-color-bar">
        <span className="m-color-dot" style={{ background: "#FFFFFF" }}></span>
        <span className="m-color-dot" style={{ background: "#808080" }}></span>
        <span className="m-color-dot" style={{ background: "#F5F5DC" }}></span>
        <span className="m-color-dot" style={{ background: "#1a1a1a" }}></span>
        <span className="m-color-dot" style={{ background: "#DC2626" }}></span>
      </div>

      <div className="m-actions">
        <button 
          className="m-btn-pill m-btn-primary"
          onClick={onHome}
        >
          Home
        </button>
        <button 
          className="m-btn-pill m-btn-secondary"
          onClick={onNovoUsuario}
        >
          Novo Usuário
        </button>
      </div>

      <div className="m-search-wrapper">
        <span className="m-search-icon">
          <IconSearch size="18px" />
        </span>
        <input
          type="text"
          placeholder="Procurar usuário..."
          className="m-search-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && (
          <button 
            className="m-search-clear" 
            onClick={() => setSearchTerm("")}
          >
            <IconClose size="16px" />
          </button>
        )}
      </div>

      <div className="m-results-count">
        {filteredUsers.length} {filteredUsers.length === 1 ? "usuário encontrado" : "usuários encontrados"}
      </div>

      <section className="m-user-list">
        {filteredUsers.map((u, index) => (
          <article 
            key={u.id} 
            className="m-user-card"
            style={{ animationDelay: `${index * 0.05}s` }}
          >
            <div className="m-user-card-topbar" />
            
            <div className="m-card-header">
              <div className="m-card-avatar">
                {getInitials(u.nome)}
              </div>
              <div className="m-card-title">
                <h4 className="m-card-name">{u.nome}</h4>
                <span className={`m-card-badge ${getNivelBadgeClass(u.nivel)}`}>
                  {u.nivel}
                </span>
              </div>
            </div>

            <div className="m-card-details">
              <div className="m-card-detail-row">
                <span className="m-card-detail-icon">
                  <IconPhone size="14px" />
                </span>
                <span className="m-card-detail-label">Telefone</span>
                <span className="m-card-detail-value">{u.telefone}</span>
              </div>
              
              {u.email && (
                <div className="m-card-detail-row">
                  <span className="m-card-detail-icon">
                    <IconEmail size="14px" />
                  </span>
                  <span className="m-card-detail-label">E-mail</span>
                  <span className="m-card-detail-value">{u.email}</span>
                </div>
              )}

              {u.status !== undefined && (
                <div className="m-card-detail-row">
                  <span className="m-card-detail-icon">
                    <IconStatus size="14px" />
                  </span>
                  <span className="m-card-detail-label">Status</span>
                  <span className={`m-card-status ${u.status ? 'status-ativo' : 'status-inativo'}`}>
                    {u.status ? 'Ativo' : 'Inativo'}
                  </span>
                </div>
              )}
            </div>

            <div className="m-card-actions">
              <button 
                className="m-card-action-btn m-action-edit" 
                title="Editar"
                onClick={() => onEditarUsuario && onEditarUsuario(u.id)}
              >
                <IconEdit size="18px" />
              </button>
              <button 
                className="m-card-action-btn m-action-view" 
                title="Visualizar"
                onClick={() => onVisualizarUsuario && onVisualizarUsuario(u.id)}
              >
                <IconEye size="18px" />
              </button>
              <button 
                className="m-card-action-btn m-action-delete" 
                title="Excluir"
                onClick={() => onExcluirUsuario && onExcluirUsuario(u.id)}
              >
                <IconTrash size="18px" />
              </button>
            </div>
          </article>
        ))}

        {filteredUsers.length === 0 && (
          <div className="m-empty-state">
            <span className="m-empty-icon">
              <IconSearch size="48px" color="var(--cor-texto-apagado)" />
            </span>
            <p>Nenhum usuário encontrado</p>
            <span className="m-empty-hint">Tente buscar por outro termo</span>
          </div>
        )}
      </section>
    </>
  );
}

export default CardsMobile;
